module.exports = "/_next/static/images/7252ca225191217cf709e30223fabe8d-cards-right-large.jpg";